<template>
    <div class="dropdown">
        <button class="btn btn-outline-medium-gray btn-outline-light w-100 dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{$t('category.limit.title')}} {{ limit }} {{$t('category.limit.products')}}.
        </button>
        <div class="dropdown-menu text-center" aria-labelledby="limit">
            <a
              href="#"
              :key="item"
              v-for="item in values"
              @click.prevent="setLimit({ limit: item})"
              :class="['dropdown-item', { active: item === limit }]">
                {{ item }} {{$t('category.limit.products')}}
            </a>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapState, mapActions } = createNamespacedHelpers('filters')

export default {

  data () {
    return {
      values: [
        8, 16, 32, 48, 96, 192
      ]
    }
  },

  computed: mapState(['limit']),

  methods: mapActions(['setLimit'])

}
</script>
